import { connect } from 'react-redux';
import { requestGoalList } from 'src/redux/actions';
import UserLayout from './userLayout';

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, { requestGoalList })(UserLayout);
